import { t } from '../../libs/translationsUtils/translations'

export function normalizeUserData (id: number, name: string, avatar: string, rank?: string, isLoggedInUser: boolean = false, isLoggedInUserSection: boolean = false, rankTitle: string = 'rank') {
  let username = name
  if (isLoggedInUser) {
    username = name.concat(' (', t('Forum', 'leaderboard.logged.in.user'), ')')
  }
  if (isLoggedInUserSection) {
    username = t('Forum', 'leaderboard.logged.in.user')
  }
  return {
    id: id,
    name: username,
    avatar: avatar,
    rank: {
      avatarIconUrl: rank,
      name: rankTitle
    }
  }
}

export function formatLeaderboardPosition (leaderboardPosition: number, points: number): string {
  if (points === 0 || leaderboardPosition === null) {
    return '-'
  }
  if (leaderboardPosition > 1000) {
    return '>1000'
  }

  return `${leaderboardPosition}`
}
